<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>微信商城</el-breadcrumb-item>
      <el-breadcrumb-item>用户管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 筛选条件 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.nickname" @keyup.enter.native="clicksearch" placeholder="请输入昵称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 筛选条件 end -->

        <!-- 数据列表 start -->
        <el-table :data="dataList" border stripe>
          <el-table-column prop="Openid" label="微信Openid" width="300px"></el-table-column>
          <el-table-column prop="Headimgurl" label="头像" width="80px">
            <template slot-scope="scope">
              <img :src="scope.row.Headimgurl" min-width="32" height="32" />
            </template>
          </el-table-column>
          <el-table-column prop="Nickname" label="昵称" width="200px"></el-table-column>
          <el-table-column prop="Name" label="收件人姓名" width="120px"></el-table-column>
          <el-table-column prop="Phone" label="收件人手机" width="160px"></el-table-column>
          <el-table-column prop="Address" label="收件人地址"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间"></el-table-column>
        </el-table>
        <!-- 数据列表 end -->

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

  </el-tabs>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
  },
  name: 'MyWxStoreUser',
  data () {
    return {
      activeName: 'first',
      optionsproduct: [],
      addForm: {
        zpgangwei: '',
        zpyaoqiu: '',
        zpdate: '',
        zpbeizhu: ''
      },
      timer: '',
      // 查询
      keywords: {
        nickname: ''
      },
      dataList: [],
      dataListnum: 0,
      selectedPageNo: 1,
      dialogVisible: false,
      apiShenPiZhaoPinSHUrl: '',
      zpid: 0
    }
  },
  mounted () {
    this.apiGetWxstoreUserNum()
    this.apiGetWxstoreUserList()
  },
  methods: {
    clicksearch () {
      this.selectedPageNo = 1
      this.apiGetWxstoreUserNum()
      this.apiGetWxstoreUserList()
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiGetWxstoreUserList()
    },
    apiGetWxstoreUserNum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        nickname: that.keywords.nickname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWxstoreUserNum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          console.log(response.data)
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWxstoreUserList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        nickname: that.keywords.nickname
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWxstoreUserList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
.cell span{
    margin-left: 10px;
}
.select2{
    width: 100%;
}

/deep/ .el-dialog__body {
    padding: 20px 20px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
</style>
